import { useTranslation } from 'react-i18next';

export const insights = () => {
  const { t } = useTranslation();

  return {
    leadCount: {
      label: t('crm.leadCount'),
      value: 'leadCount',
      key: 'LEAD'
    },
    leadActionCount: {
      label: t('crm.leadActionCount'),
      value: 'leadActionCount',
      key: 'LEAD_ACTION'
    },
    taskCount: {
      label: t('crm.taskCount'),
      value: 'taskCount',
      key: 'TASK'
    },
    callCount: {
      label: t('crm.callCount'),
      value: 'callCount',
      key: 'CALL'
    },
    callDuration: {
      label: t('crm.callDuration'),
      value: 'callDuration',
      key: 'CALL_DURATION'
    },
    successLeadCount: {
      label: t('crm.successLeadCount'),
      value: 'successLeadCount',
      key: 'SUCCESS_LEAD'
    }
  };
};
